module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Продление тарифа","add":"Добавить карту +","alarm":"!ВНИМАНИЕ!","text":"Если на выбранном Вами способе автопродления будет недостаточно средств в момент продления услуги, услуга будет остановлена. Все остальные способы автопродления будут проигнорированы системой, даже если там достаточно средств для продления."}}')
  delete Component.options._Ctor
}
